import React, { useEffect, useState } from "react";
import { Modal } from "../../ui/Modal/Modal";
import styles from "./ModalRentProgIntegrationForm.module.scss";
import { useDispatch, useSelector } from "react-redux";
import Title from "../../ui/Title/Title";
import Input from "../../ui/Input/Input";
import Button from "../../ui/Button/Button";
import { ClipLoader } from "react-spinners";
import { useModal } from "../../context/ModalContext";
import {
  setActiveDataRentProg,
  setNewDataRentProg,
} from "../../store/slices/rentProgSlice";
import RentProgIcon from "../../assets/icons/RentProgIcon";
import { stepsDataRentProg } from "../../assets/consts/tooltipDataRentProg";
import { initRentProg } from "../../utils/api/actions/integrations/rentProg";

const RentProgSuccessMessage = ({ closeModal, closeAddIntegrationModal }) => {
  const [countdown, setCountdown] = useState(5);
  const dispatch = useDispatch();

  const id = localStorage.getItem("@storage_User_Id");

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    if (countdown === 0) {
      closeModal();
      closeAddIntegrationModal();
      //   dispatch(getIntegrationsBitrixList(id));
      dispatch(setActiveDataRentProg(null));
      dispatch(setNewDataRentProg(null));
    }

    return () => clearInterval(timer);
  }, [countdown, closeModal, dispatch, id, closeAddIntegrationModal]);

  return (
    <div className={styles.successMessage}>
      <h2>Вы успешно подключили RentProg!</h2>
      <div>
        <ClipLoader /> Окно закроется через {countdown} секунд.
      </div>
    </div>
  );
};

export const ModalRentProgIntegrationForm = ({ visible, handlerClose }) => {
  const dispatch = useDispatch();

  const { closeModal } = useModal();

  const user = useSelector((state) => state?.user?.data);

  const [isRentProgConnected, setIsRentProgConnected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [companyToken, setCompanyToken] = useState("");
  const [error] = useState("");

  const hintRentProg = {
    id: "rentProg",
    stepsData: stepsDataRentProg,
  };

  const handleInputChange = (e) => {
    setCompanyToken(e.target.value);
  };

  const handleSendDataInitBitrix = () => {
    const data = {
      userId: user.id,
      companyToken: setCompanyToken,
    };
    dispatch(initRentProg(data, setLoading, setIsRentProgConnected));
    // dispatch(initBitrix(data, setLoading, setIsBitrixConnected, setError));
  };

  const handleKeyDown = (e) => {
    if (companyToken.length > 0 && e.key === "Enter") {
      handleSendDataInitBitrix();
    }
  };

  return (
    <Modal
      styleClose={styles.closeIcon}
      visible={visible}
      handleClose={handlerClose}
    >
      <div className={styles.container}>
        <div className={styles.header}>
          <Title title="Новая интеграция" className={styles.title} />
          <RentProgIcon />
        </div>
        {isRentProgConnected ? (
          <RentProgSuccessMessage
            closeModal={handlerClose}
            closeAddIntegrationModal={closeModal}
          />
        ) : (
          <div className={styles.form}>
            <div className={styles.inputContainer}>
              <Input
                onKeyPress={handleKeyDown}
                className={styles.child}
                label="Токен доступа"
                labelStyle={styles.labelInput}
                backgroundStyle={styles.labelBackground}
                inputStyle={`${styles.input} ${error ? styles.error : ""}`}
                value={companyToken}
                placeholder={"Токен"}
                type={"text"}
                hint={hintRentProg}
                onChange={handleInputChange}
              />
              {error && <div className={styles.errorMessage}>{error}</div>}
            </div>

            <Button
              onClick={handleSendDataInitBitrix}
              className={styles.button}
              titleClassName={styles.buttonTitle}
              leftIcon={
                loading ? <ClipLoader size={16} color={"white"} /> : null
              }
              title={loading ? "Подождите" : "Отправить"}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};
